// Message model
export class Message {
  constructor(id, text, sender, timestamp, aiProvider = "OpenAI", function_call = null, spatial_context = null) {
    this.id = id;
    this.text = text;
    this.sender = sender; // "user" or "bot"
    this.timestamp = timestamp;
    this.aiProvider = aiProvider;
    this.function_call = function_call;
    this.spatial_context = spatial_context;
  }
}

// Spatial context model
export class SpatialContext {
  constructor(current_sweep = null, current_position = null, current_tag = null, space_info = null) {
    this.current_sweep = current_sweep;
    this.current_position = current_position;
    this.current_tag = current_tag;
    this.space_info = space_info;
  }
}

// Matterport tag model
export class MatterportTag {
  constructor(id, label, description = "", position = {}, sweep = "", stemVector = null) {
    this.id = id;
    this.label = label;
    this.description = description;
    this.position = position;
    this.sweep = sweep;
    this.stemVector = stemVector; // surface normal — used for occlusion backface culling
  }
}

// Chat request model
export class ChatRequest {
  constructor(message, conversation_id = null, conversation_history = [], spatial_context = null) {
    this.message = message;
    this.conversation_id = conversation_id;
    this.conversation_history = conversation_history;
    this.spatial_context = spatial_context;
  }
}

// Chat response model
export class ChatResponse {
  constructor(response, conversation_id, sources = [], function_call = null, spatial_context = null) {
    this.response = response;
    this.conversation_id = conversation_id;
    this.sources = sources;
    this.function_call = function_call;
    this.spatial_context = spatial_context;
  }
}

// Navigation request model
export class NavigationRequest {
  constructor(target_label, conversation_id = null) {
    this.target_label = target_label;
    this.conversation_id = conversation_id;
  }
}

// Spatial update request model
export class SpatialUpdateRequest {
  constructor(current_sweep = null, current_position = null, current_tag = null, space_info = null) {
    this.current_sweep = current_sweep;
    this.current_position = current_position;
    this.current_tag = current_tag;
    this.space_info = space_info;
  }
}

// Function call request model
export class FunctionCallRequest {
  constructor(function_name, parameters = {}) {
    this.function_name = function_name;
    this.parameters = parameters;
  }
}

// Matterport SDK state model
export class MatterportState {
  constructor() {
    this.sdk = null;
    this.isConnected = false;
    this.tags = [];
    this.spatialContext = new SpatialContext();
    this.currentSweep = null;
    this.currentTag = null;
  }
}

// Chat state model
export class ChatState {
  constructor() {
    this.messages = [];
    this.isTyping = false;
    this.conversationId = null;
    this.isOpen = false;
    this.isMinimized = false;
  }
} 